import { NoddiCheckbox, NoddiCheckboxProps } from '@ui-components/Inputs/NoddiCheckbox';
import { useFieldContext } from '../formContext';
import { TanstackFieldError } from '../TanstackFieldError';
import { useTanstackFieldAria } from '../useTanstackFieldAria';

type Props = Omit<NoddiCheckboxProps, 'checked' | 'onCheckedChange'>;

export const TanstackFormCheckbox = (checkboxProps: Props) => {
  const field = useFieldContext<boolean>();
  const fieldAria = useTanstackFieldAria(field, checkboxProps['aria-describedby']);

  return (
    <div>
      <NoddiCheckbox
        checked={field.state.value}
        {...checkboxProps}
        id={checkboxProps.id ?? field.name}
        {...fieldAria}
        onCheckedChange={(checked) => field.handleChange(checked)}
      />
      <TanstackFieldError field={field} />
    </div>
  );
};
